const EMPTY_BLOCK_TAG_PATTERN = /<(?:p|div)(?:\s[^>]*)?>\s*<\/(?:p|div)>/gi;

/**
 * Magento/CMS often wraps lists in <p>, which is invalid HTML and breaks Vue SSR.
 */
function repairParagraphsWrappingBlockContent(html: string): string {
  let normalized = html;

  normalized = normalized.replace(
    /<p(?:\s[^>]*)?>\s*(<(?:ul|ol|div|table|blockquote)\b)/gi,
    '$1'
  );

  normalized = normalized.replace(
    /(<\/(?:ul|ol|div|table|blockquote)>)\s*<\/p>/gi,
    '$1'
  );

  normalized = normalized.replace(
    /<p(?:\s[^>]*)?>([\s\S]*?)(<(?:ul|ol|div|table|blockquote)\b)/gi,
    (match, inlineContent: string, blockTag: string) => {
      if (inlineContent.includes('</p>')) {
        return match;
      }

      const trimmedInlineContent = inlineContent.trim();

      if (!trimmedInlineContent) {
        return blockTag;
      }

      return `<p>${trimmedInlineContent}</p>${blockTag}`;
    }
  );

  return normalized;
}

/**
 * Trims a CMS HTML fragment for PDP header rendering.
 * Preserves block markup (lists, paragraphs, inline formatting) intact.
 */
export function sanitizePdpDescriptionHtmlFragment(html: string): string {
  let normalized = html.trim();

  if (!normalized) {
    return '';
  }

  normalized = normalized.replace(EMPTY_BLOCK_TAG_PATTERN, '');
  normalized = repairParagraphsWrappingBlockContent(normalized);

  return normalized.trim();
}

export interface BuildPdpHeaderDescriptionOptions {
  isDiscontinued?: boolean;
}

/**
 * Merges seo_headline and teaser_text for ProductDetailHeader.
 * Block elements and inline formatting are preserved for v-html rendering.
 */
export function buildPdpHeaderDescription(
  shortHtml: string | undefined,
  longHtml: string | undefined,
  options: BuildPdpHeaderDescriptionOptions = {}
): string {
  if (options.isDiscontinued) {
    return '';
  }

  const shortText = sanitizePdpDescriptionHtmlFragment(shortHtml ?? '');
  const longText = sanitizePdpDescriptionHtmlFragment(longHtml ?? '');

  if (shortText && longText) {
    return `${shortText}<br><br>${longText}`;
  }

  return shortText || longText;
}
